import { render, staticRenderFns } from "./Authorised.vue?vue&type=template&id=025db0e5&"
import script from "./Authorised.vue?vue&type=script&lang=ts&"
export * from "./Authorised.vue?vue&type=script&lang=ts&"
import style0 from "./Authorised.vue?vue&type=style&index=0&id=025db0e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports